import type { OrganizationThemeTokens } from '@interfaces/organization';

export const replaceEmptyStringsWithUndefined = <T>(obj: T): T => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (typeof obj === 'string') {
    return (obj === '' ? undefined : obj) as T;
  }

  if (Array.isArray(obj)) {
    return obj.map(replaceEmptyStringsWithUndefined) as T;
  }

  if (typeof obj === 'object') {
    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(obj)) {
      result[key] = replaceEmptyStringsWithUndefined(value);
    }
    return result as T;
  }

  return obj;
};

export const processThemeTokens = (
  themeTokens: OrganizationThemeTokens | null | undefined,
): OrganizationThemeTokens | null | undefined => {
  if (!themeTokens) {
    return themeTokens;
  }

  return replaceEmptyStringsWithUndefined(themeTokens);
};
